import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {ComboBox, DefaultButton, Panel, PanelType, PrimaryButton, Stack} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";

function MergePerson(props) {
    const [user] = useContext(AuthContext);
    const [target, setTarget] = useState(null);

    const _submit = (e) => {
        e.preventDefault();
        fetch(`/api/person/${props.edit.id}/mergeto/${target.key}`, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='MergePerson'>Połącz</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        if (props.edit) {
            setTarget(null);
        }
    }, [props.edit])

    const personList = props.edit.persons?.filter(item => item.id !== props.edit.id && item.name !== null).map((item) => {return {key: item.id, text: `${item.surname} ${item.name} (${item.email})`}})

    return (
        <Panel
            isOpen={props.edit}
            onDismiss={props.dismissPanel}
            headerText="Połącz Osobę"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
            type={PanelType.medium}
        >
            <p>{props.edit.keystring}</p>
            <form onSubmit={_submit} id='MergePerson'>
                <ComboBox
                    label="Dołącz do"
                    selectedKey={target ? target.key : undefined}
                    onChange={(e, item) => setTarget(item)}
                    placeholder="Wybierz z listy"
                    options={personList}
                    autofill={true}
                />
            </form>
        </Panel>
    )
}

export default MergePerson;